var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "downlineRepContainer",
    staticClass: "page-wrapper downlinerep-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  }), _c('div', {
    staticClass: "page-title emp-grp-title"
  }, [_c('div', {
    staticClass: "grp-title"
  }, [_c('h1', {
    staticClass: "mb-0"
  }, [_vm._v("Downline Reps")]), !_vm.isEnrollPrime ? _c('div', {}, [_c('a', {
    staticClass: "new-btn",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.addNewDownline.apply(null, arguments);
      }
    }
  }, [_vm._v(" Add New ")]), _c('a', {
    staticClass: "registration-link reg-link-btn",
    staticStyle: {
      "background": "#3bb54a !important"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.openRegistrationLinkModel('sendEmailRegistrationLink');
      }
    }
  }, [_vm._v(" Send Registration Link ")]), _c('a', {
    staticClass: "reg-link-log-btn reg-link-btn ms-2",
    staticStyle: {
      "background": "#cb8531 !important"
    },
    attrs: {
      "href": "/view-reg-log"
    }
  }, [_vm._v(" View Registration Link Logs ")])]) : _vm._e()]), _c('button', {
    staticClass: "clear-search",
    on: {
      "click": _vm.clearDownline
    }
  }, [_vm._v(" Clear Search ")])]), _c('downline-rep-list-filter', {
    attrs: {
      "filters": _vm.filterQuery,
      "active-quick-filter": _vm.activeQuickFilter
    },
    on: {
      "onSearch": _vm.filterData,
      "quick-filter": _vm.setQuickDateFilter
    }
  }), _c('div', {
    staticClass: "downlinedata-card"
  }, [_c('div', {
    staticClass: "top-pagination"
  }, [_c('pagination', {
    attrs: {
      "rows": _vm.rows,
      "filters": _vm.filterQuery
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.rows = $event;
      }
    }
  })], 1), _c('downline-rep-list-table', {
    attrs: {
      "rows": _vm.rows,
      "is-initial-load": _vm.isFirstLoad,
      "active-quick-filter": _vm.activeQuickFilter
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.rows = $event;
      },
      "onSuccess": function onSuccess($event) {
        return _vm.getAll(_vm.filterQuery);
      },
      "quick-filter": _vm.setQuickDateFilter
    }
  }), _c('send-registration-link-email-modal'), _c('downline-registration-contract-modal', {
    on: {
      "redirectToRegistrationPage": _vm.redirectToRegistrationPage
    }
  }), _c('pagination', {
    attrs: {
      "rows": _vm.rows,
      "filters": _vm.filterQuery
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.rows = $event;
      }
    }
  })], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }